function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function NotificationDisabled({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.603 20.934a1 1 0 110 2h-3.72a1 1 0 010-2h3.72zM12.895 1.06a7.79 7.79 0 012.044.507c1.309.517 2.387 1.415 3.161 2.623l2.792-2.813a.999.999 0 111.42 1.408L2.71 22.54a.999.999 0 11-1.42-1.408l1.541-1.552c-.422-.304-.688-.83-.81-1.332-.4-1.389.465-2.705 1.503-3.375.404-.26.61-.577.61-1.577v-2.877c0-.242-.006-.486-.01-.732-.019-.864-.037-1.756.14-2.653.513-2.6 2.074-4.593 4.282-5.466a7.792 7.792 0 012.043-.507c.76-.08 1.55-.08 2.306 0zm5.457 8.358a1 1 0 011 1v2.877c0 1 .205 1.317.609 1.577 1.037.67 1.903 1.986 1.494 3.412-.177.734-.702 1.557-1.612 1.557h-9.96a1 1 0 110-2H19.5a.721.721 0 00.022-.068c.13-.458-.23-.952-.648-1.221-1.35-.873-1.523-2.199-1.523-3.257v-2.877a1 1 0 011-1zM10.8 3.048a5.865 5.865 0 00-1.518.378c-2.139.847-2.833 2.867-3.056 3.995-.135.685-.12 1.432-.104 2.223.006.259.011.518.011.774v2.877c0 1.058-.173 2.384-1.523 3.257-.418.269-.778.763-.658 1.184.01.035.021.071.033.105h.473v.097l12.186-12.28c-.56-1.05-1.4-1.82-2.44-2.232a5.882 5.882 0 00-1.52-.378 9.267 9.267 0 00-1.884 0z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoNotificationDisabled = React.memo(NotificationDisabled);
export default MemoNotificationDisabled;